import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Popover, Space, Tag } from 'antd';
import React, { useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline, MdSubtitles } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { deleteLeaveType, getLeaveType } from '../../network/leaveType';
import {
  deleteLeaveAllocation,
  getLeaveAllocation,
} from '../../network/leaveAllocation';
import StatusTag from '../../hooks/StatusHook';
import { TiCancel } from 'react-icons/ti';
import {
  cancelMaterialRequest,
  submitMaterialRequest,
} from '../../network/materialRequest';
import {
  deleteLeavePolicyAssign,
  getLeavePolicyAssign,
} from '../../network/leavePolicyAssign';
import { ModalAddLeavePolicyAssign } from '../../components/upeosoft/ModalApp/ModalApp';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import DashboardCards from '../Dashboard/DashboardCards';
const LeavePolicyAssign = ({ t }) => {
  const navigate = useNavigate();
  const client = useQueryClient();
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const { message } = App.useApp();
  const handleRemove = useMutation({
    mutationFn: (id) => deleteLeavePolicyAssign(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getLeavePolicyAssign] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleCancle = useMutation({
    mutationFn: (id) => cancelMaterialRequest('Leave Policy Assignment', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Cancled successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getLeaveAllocation] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Leave Policy Assignment', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getLeavePolicyAssign] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getLeavePolicyAssign],
    queryFn: () => getLeavePolicyAssign(),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.leavePolicy,
      icon: <MdModeEditOutline />,
      onClick: () => {
        setEditId(record?.name);
        setEdit(true);
        setOpen(true);
      },
    },
    {
      key: '2',
      label: t.submit + ' ' + t.leavePolicy,
      icon: <MdSubtitles />,
      onClick: () => {
        handleSubmit.mutate(record?.name);
      },
      disabled: record?.docstatus !== 0,
    },
    {
      key: '3',
      label: t.cancel + ' ' + t.leavePolicy,
      icon: <TiCancel />,
      onClick: () => {
        handleCancle.mutate(record?.name);
      },
      disabled: record?.docstatus !== 1,
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.DeleteLeavePolicy + ` (${record?.name})`}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record?.name)}
          // onCancel={cancel}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.leavePolicy}
          </span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
      disabled: record?.docstatus !== 1,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      key: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record?.name).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
    },
    {
      title: t.employeeName,
      dataIndex: 'employee_name',
      key: 'employee_name',
    },
    {
      title: t.leavePolicy,
      dataIndex: 'leave_policy',
      key: 'leave_policy',
    },
    {
      title: t.status,
      dataIndex: 'docstatus',
      key: 'docstatus',
      render: (status) => <StatusTag status={status} />,
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 200,
      render: (text, record) => {
        return (
          <Space>
            {/* <Button size="small" type="primary"
              onClick={() => {
                setEditId(record?.name);
                setEdit(true);
                setOpen(true);
              }}
              icon={<MdModeEditOutline />}
              />
               {
              (record?.docstatus === 0 && (
                <Popover
                  placement="top"
                  title={t.submit}
                  onClick={() => {
                    handleSubmit.mutate(record?.name);
                  }}
                >
                  <Button
                    size="small"
                    type="primary"
                    style={{ backgroundColor: '#28a745' }}
                    icon={<MdSubtitles />}
                  />
                </Popover>
              ))}
              {
              (record?.docstatus === 1 && (
                <Popover
                  placement="top"
                  title={t.Cancel}
                  onClick={() => {
                    handleCancle.mutate(record?.name);
                  }}
                >
                  <Button
                    size="small"
                    type="primary"
                    style={{ backgroundColor: '#ff4d4f' }}
                    icon={<TiCancel />}
                  />
                </Popover>
              ))}
              {
              record?.docstatus !== 1 && 
            <Popconfirm
              title={t.DeleteLeavePolicy + ` (${record?.name})`}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger 
              icon={<MdDelete />}
              />
            </Popconfirm>
      } */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="leave-type">
      {/* <Heading title={t.HR } subTitle={t.leavePolicyAssign} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          Placeholder={t.searchByName}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                setOpen(true);
                setEdit(false);
                setEditId(null);
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.addLeavePolicyAssign}
            </Button>
          }
        />
      </div>
      <ModalAddLeavePolicyAssign
        t={t}
        open={open}
        setOpen={setOpen}
        editId={editId}
        edit={edit}
        setEdit={setEdit}
      />
    </div>
  );
};

export default LeavePolicyAssign;
